import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/react'
import arrowRightPrimary from '../images/svgs/arrow-right-primary.svg'

const cardContainerStyle = theme => css({
    display: 'flex',
    justifyContent: 'space-between', // push CTA to bottom
    flexDirection: 'column',
    border: `1px solid ${theme.colors.mutedDark}`,
    padding: 16,
})

const titleStyle = theme => css({
    color: 'white',
    fontFamily: theme.fonts.secondary,
    fontSize: 16,
})

const categoryStyle = theme => css({
    fontSize: 13,
    marginTop: 12,
    textTransform: 'uppercase',
    color: theme.colors.mutedLight,
})

const descriptionStyle = theme => css({
    textTransform: 'capitalize',
    color: theme.colors.mutedLight,
    marginTop: 12,
    marginBottom: 0,
})

const ctaStyle = theme => css({
    textTransform: 'uppercase',
    color: theme.colors.primary,
    fontWeight: 700,
    marginTop: 16,
    marginBottom: 0,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
})

function Card({ product, large }){
    const { data: { thumbnail, name, categories, shortDescription, }} = product || {}
    return(
        <>
            <div>
                <div css={{ overflow: 'hidden' }}>
                    <img 
                        src={thumbnail} 
                        alt={name}
                        css={{ width: '100%',}}
                    />
                </div>
                <div css={{ marginTop: 16 }}>
                    <h5 css={titleStyle} style={large ? { fontSize: 20 } : {}}>
                        {name}
                    </h5>
                    <h6 css={categoryStyle}>
                        {categories.lvl0}
                    </h6>
                    <p css={descriptionStyle}>
                        {shortDescription}
                    </p>
                </div>
            </div>
            <p className='product-card-cta' css={ctaStyle}>
                Discover
                <img src={arrowRightPrimary} alt="Arrow" />
            </p>
        </>
    )
}

export default function ProductCard(props){
    const { product, external } = props
    const { data: { url }} = product || {}
    if(external){
        return(
            <a className='product-card' href={url} target='_blank' css={cardContainerStyle}>
                <Card {...props} />
            </a>
        )
    } else {
        return(
            <Link className='product-card' to={url} css={cardContainerStyle}>
                <Card {...props} />
            </Link>
        )
    }
}
